import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { FilterModelItemEntity } from '../../../domain/filter-model-item.entity';

export enum FilterModelFormControls {
	Id = 'id',
	Label = 'label',
	Description = 'description',
}

@Injectable()
export class FilterModelMetadataForm {
	public form: FormGroup;

	public constructor(protected readonly fb: FormBuilder) {
		this.form = this.fb.group({
			[FilterModelFormControls.Id]: [
				{
					value: -1,
				},
			],
			[FilterModelFormControls.Label]: [
				'',
				[Validators.required, Validators.maxLength(256)],
			],
			[FilterModelFormControls.Description]: ['', [Validators.maxLength(2500)]],
		});
	}

	public extract(): FilterModelItemEntity {
		const formValues = this.form.value;
		return FilterModelItemEntity.build({
			id: formValues[FilterModelFormControls.Id] ?? -1,
			label: formValues[FilterModelFormControls.Label] ?? '',
			description: formValues[FilterModelFormControls.Description] ?? '',
		});
	}

	public populate(config: Partial<FilterModelItemEntity> | null): void {
		if (config === null || config.id === undefined) {
			throw new Error('Invalid entity');
		}
		this.form.patchValue({
			[FilterModelFormControls.Id]: config.id,
			[FilterModelFormControls.Label]: config?.label ?? '',
			[FilterModelFormControls.Description]: config?.description ?? '',
		});
	}
}
